<template>
  <div class="container" style="height:100%">
    <el-container style="height:100%">
  <el-header><theHeader></theHeader></el-header>
  <el-container style="height:100%">
    <el-aside width="200px;height:100%">
       <el-menu
        style="height:100%" 
        class="el-menu-vertical-demo"
        background-color="#e9eef7"
        text-color="#333"
        unique-opened
        active-text-color="#2e5597">
      <el-submenu :index="item.questioncategory.id" v-for="(item,i) in tablist" :key="item.id">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span @click="bindmenu(item)">{{item.questioncategory.name}}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item :index="item1.id" v-for="(item1,a) in item.helpQuestionsList" :key="item1.id" @click="bindtab(item,item1,i,a)">{{item1.title}}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
     
    </el-menu>

    </el-aside>
    <el-main>
        <div class=""><el-breadcrumb separator-class="el-icon-arrow-right">
               <el-breadcrumb-item >帮助中心</el-breadcrumb-item>
               <el-breadcrumb-item v-for="item in tabval" :key="item.name">{{item.name}}</el-breadcrumb-item>
               </el-breadcrumb>
        </div>
         <div class="quesion_title">
            {{content.title}}
         </div>
         <div class="ques_content" v-html="content.content">
      
         </div>
    </el-main>
  </el-container>
</el-container>
  </div>
</template>

<script>
import theHeader from "@/components/layout/Header.vue";

export default {
  components: {
    theHeader
  },
  data(){
    return{
      tablist:[],
      tabval:[],
      content:{},
    }
  },
  methods:{
    // 获取帮助列表
    gettab(){
     this.$axios.post("/user/questionCategory/getAllQuestion").then(res=>{
        if(res.data.result){
          this.tablist=res.data.data
        }
     })
    },
    // 点击tab
    bindtab(i,e,s,a){
      console.log(i,e)
      const tabval=[{name:i.questioncategory.name},{name:e.title}]
       this.tabval=tabval
       this.content=this.tablist[s].helpQuestionsList[a]
    },
//     bindmenu(item){
//        this.active=String(item.questioncategory.id
//  )    }

  },
  created(){
    this.gettab()
  }
};
</script>

<style>
.quesion_title{
  width: 100%;
  height:80px;
  line-height: 80px;
  text-align: center;
  font-size: 20px;
}
.ques_content{
  width: 100%;
  border-bottom: 1px solid #f8f8f8;
  border-top: 1px solid #f8f8f8;
  padding:30px 0;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/helplist.vue